import React, { useState } from 'react';
import { Table, Form, Input, Select, Statistic, Button } from 'antd';
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons';
const { Option } = Select;
var _ = require('lodash');

const columns = [
    {
        title: 'Parameter',
        dataIndex: 'parameter',
        width: 250,
        onCell: (_, index) => {
            if (index === 0) {
                return { rowSpan: 4 };
            }
            if (index === 4) {
                return { rowSpan: 5 };
            }
            if (index === 9 || index === 10) {
                return {}
            }
            return { rowSpan: 0 };
        },
    },
    {
        title: 'Quality Parameter',
        dataIndex: 'sub_parameter',
    },
    {
        title: "Feedback",
        dataIndex: "feedback",
        width: 350,
        render: (_, record) => {
            if (record.disabled) {
                return <p>{record.selected_option}</p>
            }
            return <Form.Item
                name={record.key}
                rules={[{ required: true, message: "Please select" }]}
            >
                <Select defaultValue={record.score} disabled={record.disabled} onSelect={(score) => record.updateFunction(record.key, score)}>
                    {record.input_options.map(item => <Option value={item.score}>{item.option}</Option>)}
                </Select>
            </Form.Item>
        },
    },
    {
        title: 'Score',
        dataIndex: 'score',
        width: 200,
        align: "center",
        key: 'score',
    },
];
const parameters = [
    {
        key: 'qa_qc_engineers',
        category: 'Quality',
        parameter: 'Quality plan & practice',
        sub_parameter: 'Deployment of required QA/QC Engineers',
        score: 0,
        input_options: [{ option: '95% - 100%', score: 4 }, { option: '80% - 94%', score: 3 }, { option: '70% - 79%', score: 2 }, { option: '<70%', score: 0 }],
        weight: 5,
        weighted_score: 0,
    },
    {
        key: 'qa_plan_practice',
        category: 'Quality',
        parameter: 'Quality plan & practice',
        sub_parameter: 'Quality inspection performed as per stipulated freqency in inspection & material test plan.',
        input_options: [{ option: 'Yes', score: 4 }, { option: 'Minor Deviation', score: 2 }, { option: 'No', score: 0 }],
        score: 0,
        weight: 10,
        weighted_score: 0,
    },
    {
        key: 'request_for_inspection',
        category: 'Quality',
        parameter: 'Quality plan & practice',
        sub_parameter: 'Request for inspection which are first time right - >95%',
        input_options: [{ option: '>95%', score: 4 }, { option: '86% - 95%', score: 3 }, { option: '76% - 85%', score: 2 }, { option: '65% - 75%', score: 1 }, { option: '<65%', score: 0 }],
        score: 1,
        weight: 5,
        weighted_score: 0,
    },
    {
        key: 'quality_audit',
        category: 'Quality',
        parameter: 'Quality plan & practice',
        sub_parameter: 'Quality audit performed as per QAP/Contratual Clause & no repeated findings',
        score: 0,
        input_options: [{ option: 'No repeated findings', score: 4 }, { option: 'No major repeated findings', score: 2 }, { option: 'Repeated findings', score: 0 }],
        weight: 5,
        weighted_score: 0,
    },
    {
        key: 'inspection_incoming_material',
        category: 'Quality',
        parameter: 'Inspection and documentation',
        sub_parameter: 'Inspection of incoming material to be concluded within 3 days of receipt',
        score: 0,
        input_options: [{ option: '<3 days', score: 4 }, { option: '3-5 days', score: 3 }, { option: '5-7 days', score: 2 }, { option: '>7 days', score: 0 }],
        weight: 5,
        weighted_score: 0,
    },
    {
        key: 'report_submission',
        category: 'Quality',
        parameter: 'Inspection and documentation',
        score: 0,
        sub_parameter: 'Submission of weekly & monthly quality reports (as per contract) by target date of next week/ month',
        input_options: [{ option: 'Submitted by Target Date', score: 4 }, { option: 'Within 2 Days from Target Date', score: 3 }, { option: 'Within 5 Days from Target Date', score: 2 }, { option: 'Submitted after 5 Days', score: 0 }],
        weight: 10,
        weighted_score: 0,
    },
    {
        key: 'approval_of_wms',
        category: 'Quality',
        parameter: 'Inspection and documentation',
        score: 0,
        sub_parameter: 'Submission & Approval of WMS (SOP/Method Statement) pertaining to new activity',
        input_options: [{ option: '15 days before', score: 4 }, { option: '5 days before', score: 3 }, { option: '3 days before', score: 2 }, { option: '<3 days', score: 0 }],
        weight: 5,
        weighted_score: 0,
    },
    {
        key: 'reduction_ncr',
        category: 'Quality',
        parameter: 'Inspection and documentation',
        score: 0,
        sub_parameter: 'Reduction in repeated NCR & Observations',
        input_options: [{ option: 'No repetition', score: 4 }, { option: 'Repetition within 3 months', score: 3 },{ option: 'Repetition within 2 months', score: 2 }, { option: 'Repetition within 1 month', score: 0 }],
        weight: 10,
        weighted_score: 0,
    },
    {
        key: 'complaints_qow',
        category: 'Quality',
        parameter: 'Inspection and documentation',
        score: 0,
        sub_parameter: 'Complaints regarding Quality of work',
        input_options: [{ option: 'No NCR', score: 4 }, { option: 'Minor NCR <= 2', score: 3 }, { option: 'Minor NCR <= 4', score: 2 }, { option: 'Major NCR', score: 0 }],
        weight: 10,
        weighted_score: 0,
    },
    {
        key: 'monthly_quality_index',
        category: 'Quality',
        parameter: 'Quality Audit',
        sub_parameter: 'Monthly Quality Index',
        score: 0,
        input_options: [{ option: '>90%', score: 4 }, { option: '81% - 90%', score: 3 }, { option: '71% - 80%', score: 2 }, { option: '60% - 70%', score: 1 }, { option: '<60%', score: 0 }],
        weight: 15,
        weighted_score: 0,
    },
    {
        key: 'non_comformance',
        category: 'Quality',
        parameter: 'Non-conformance/ Field Observation',
        score: 0,
        sub_parameter: '',
        weight: 20,
        weighted_score: 0,
        input_options: [{ option: 'NCRs within 7 days', score: 4 }, { option: 'NCRs within 15 days', score: 3 },
        { option: 'NCRs within 30 days', score: 2 }, { option: 'NCRs within 60 days', score: 1 }, { option: 'NCRs more than 60 days', score: 0 }],
    },
];

const QualityFeedback = ({ updateScore, disabled, initialValues }) => {
    const updateData = (key, score) => {
        let count = 0
        let updateData = data.map(item => {
            if (item.key == key) {
                item.score = score
                item.weighted_score = (score * item.weight) / 100
            }
            count = count + item.weighted_score
            return item;
        })
        setWeightedScore(count)
        setData(updateData)
        updateScore("Quality", updateData)
    }
    const [weightedScore, setWeightedScore] = useState(0)

    const [data, setData] = useState(() => {
        let count = 0;
        let updatedParameters = parameters.map(item => {
            item.updateFunction = updateData
            item.disabled = disabled
            if (initialValues) {
                let option = initialValues.scores.filter(x => x.key == item.key)
                if (option.length > 0) {
                    item.selected_option = option[0].selected_option
                    item.score = option[0].score
                    item.weighted_score = option[0].weighted_score
                    count += option[0].weighted_score
                } else {
                    item.selected_option = ""
                }
            }
            return item;
        })
        setWeightedScore(count)
        return updatedParameters;
    });

    return (
        <>
            {!disabled && <>
                <div style={{ padding: "10px", float: "right", marginRight: "15px", background: "white", border: "1px solid lightgray", borderRadius: "10px" }}>
                    <Statistic
                        title="Overall Quality"
                        valueStyle={{ color: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                        prefix={weightedScore < 3 ? <DislikeOutlined /> : <LikeOutlined />}
                        value={weightedScore}
                        precision={2} />
                </div>
                <br /><br /><br /><br /></>}
            <div className='form-box' >
                {(initialValues.scores.some(obj => obj.category === 'Quality')) ?
                    <div className='score-legend' 
                    style={{ background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}>
                        <p style={{ margin: "0px" }}>Overall Quality Score - {weightedScore.toFixed(2)}</p>
                    </div> :
                    <div className='score-legend' style={{ background: '#838383' }}>
                        <p style={{ margin: "0px" }}>Quality Feedack Pending</p>
                    </div>}
                <Table
                    bordered={true}
                    columns={columns}
                    size="small"
                    pagination={false}
                    dataSource={_.cloneDeep(data)} />
            </div>


        </>
    );
}
export default QualityFeedback;